import { render, staticRenderFns } from "./product-choose.vue?vue&type=template&id=46798392&scoped=true&"
import script from "./product-choose.vue?vue&type=script&lang=js&"
export * from "./product-choose.vue?vue&type=script&lang=js&"
import style0 from "./product-choose.vue?vue&type=style&index=0&id=46798392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46798392",
  null
  
)

export default component.exports